const PictureDescription = ({ description }) => {
    return (
        <div className="pictureDescription">
            <p>{description}</p>
        </div>
    )
}
export default PictureDescription;